import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/Navbar";


function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
